import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignUpComponent } from './sign-up/sign-up.component';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HttpService } from './http.service';
import { ValidationService } from './validation.service';
import { HeaderComponent } from './header/header.component';
import { OrderDashboardComponent } from './order-dashboard/order-dashboard.component';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SnackbarService } from './snackbar.service';
import { StorageService } from './storage.service';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule, MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter, MatPaginatorModule, MatBadgeModule, MAT_DATE_LOCALE, MatDividerModule, MatSliderModule } from '@angular/material';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AcceptModalComponent } from './dashboardModals/accept-modal/accept-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
// import { MatProgressBar } from '@angular/material/progress-bar';

// import { MatPaginatorModule } from '@angular/material/paginator';
import { OurDateAdapter } from './nativeDatePicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { GaugeChartModule } from 'angular-gauge-chart';
import { NgxEchartsModule } from 'ngx-echarts';


import { AssignModalComponent } from './dashboardModals/assign-modal/assign-modal.component';
import { RateCardBasicComponent } from './rate-card-basic/rate-card-basic.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { EntityDetailsComponent } from './entity-details/entity-details.component';
import { FeaturesComponent } from './userEntityModals/features/features.component';
import { RolesComponent } from './userEntityModals/roles/roles.component';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { VehiclesDashboardComponent } from './vehicles-dashboard/vehicles-dashboard.component';
import { AddVehicleComponent } from './vehicles/add-vehicle/add-vehicle.component';
import { DriversComponent } from './drivers/drivers.component';
import { AddDriverComponent } from './drivers/add-driver/add-driver.component';
import { AttendanceComponent } from './attendance/attendance.component';
import { ShipmentsDashboardComponent } from './shipments-dashboard/shipments-dashboard.component';
import { MapModalComponent } from './map-modal/map-modal.component';
import { SocketService } from './socket.service';
import { ShipmentDetailsComponent } from './dashboardModals/shipment-details/shipment-details.component';

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
import { PostShipmentComponent } from './post-shipment/post-shipment.component';
import { SearchPipe } from './post-shipment/search.pipe';
import { FavoriteLocationComponent } from './favorite-location/favorite-location.component';
import { AccessoriesComponent } from './accessories/accessories.component';
import { PermitsComponent } from './permits/permits.component';
import { LoadTypeComponent } from './load-type/load-type.component';
import { OrganisationNameComponent } from './organisation-name/organisation-name.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HelpComponent } from './help/help.component';
import { BidOrderComponent } from './bid-order/bid-order.component';
import { OpenBidsComponent } from './open-bids/open-bids.component';
import { BidDetailsModalComponent } from './open-bids/bid-details-modal/bid-details-modal.component';
import { AttachDriverComponent } from './attach-driver/attach-driver.component';
import { AttachVehicleComponent } from './attach-vehicle/attach-vehicle.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { DriverMapViewComponent } from './driver-map-view/driver-map-view.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthInterceptor } from './http.interceptor';
import { InvoicesComponent } from './invoices/invoices.component';
import { BillsComponent } from './bills/bills.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CreateBillComponent } from './create-bill/create-bill.component';
import { CreateBillModalComponent } from './create-bill/create-bill-modal/create-bill-modal.component';
import { DeleteBillModalComponent } from './bills/delete-bill-modal/delete-bill-modal.component';
import { ShipmentsMapComponent } from './shipments-map/shipments-map.component';
import { UnitSettingsComponent } from './unit-settings/unit-settings.component';
import { ShareComponent } from './share/share.component';
import { SpotOnDriverComponent } from './spot-on-driver/spot-on-driver.component';
import { DriverPathComponent } from './driver-path/driver-path.component';
import { TaxSettingsComponent } from './tax-settings/tax-settings.component';
import { MyShippersComponent } from './my-shippers/my-shippers.component';
import { EditVehicleComponent } from './vehicles/edit-vehicle/edit-vehicle.component';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { SpotDriversComponent } from './spot-drivers/spot-drivers.component';
import { ViewDriverComponent } from './drivers/view-driver/view-driver.component';
import { ViewVehicleComponent } from './vehicles/view-vehicle/view-vehicle.component';
import { MessagingService } from './messaging.service';
import { ReAssignComponent } from './re-assign/re-assign.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatExpansionModule } from '@angular/material/expansion';
import { SendEmailComponent } from './share/send-email/send-email.component';
import { GanttDashboardComponent } from './gantt-dashboard/gantt-dashboard.component';
import { CanvasComponent } from './canvas/canvas.component';
import { AddUserComponent } from './user-details/add-user/add-user.component';
import { AddUnitComponent } from './entity-details/add-unit/add-unit.component';
import { DeletedShipmentsComponent } from './deleted-shipments/deleted-shipments.component';
import { NumberFormatPipe } from './number-format.pipe';
import { SnackbarNotifComponent } from './snackbar-notif/snackbar-notif.component';
import { OverviewComponent } from './overview/overview.component';
import { DeadlineModalsComponent } from './dashboardModals/deadline-modals/deadline-modals.component';
import { PreShipmentModalsComponent } from './dashboardModals/pre-shipment-modals/pre-shipment-modals.component';
import { PostShipmentModalsComponent } from './dashboardModals/post-shipment-modals/post-shipment-modals.component';
import { DashboardSettingsComponent } from './dashboard-settings/dashboard-settings.component';
import { InvoicePreviewComponent } from './invoice-preview/invoice-preview.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { InvoiceHistoryComponent } from './create-bill/invoice-history/invoice-history.component';
import { PaymentVoucherComponent } from './payment-voucher/payment-voucher.component';
import { PaymentVoucherCreateComponent } from './payment-voucher/payment-voucher-create/payment-voucher-create.component';
import { PaymentVoucherViewComponent } from './payment-voucher/payment-voucher-view/payment-voucher-view.component';
import { PaymentAdviceComponent } from './payment-advice/payment-advice.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { RoleGuard } from './role.guard';
import { CreditNoteComponent } from './bills/credit-note/credit-note.component';
import { CreditNotesComponent } from './credit-notes/credit-notes.component';
import { DebitNotesComponent } from './debit-notes/debit-notes.component';
import { DbclickDirective } from './dbclick.directive';
import { HolidayListComponent } from './holiday-list/holiday-list.component';
import { AddOwnFleetDriverComponent } from './add-own-fleet-driver/add-own-fleet-driver.component';
import { DocPreviewComponent } from './doc-preview/doc-preview.component';
import { AddAttendanceComponent } from './drivers/add-attendance/add-attendance.component';
import { HolidaysListComponent } from './drivers/holidays-list/holidays-list.component';
import { BulkUploadVehicleComponent } from './bulk-upload-vehicle/bulk-upload-vehicle.component';
import { AttendanceSalaryComponent } from './attendance-salary/attendance-salary.component';
import { ViewAttendanceComponent } from './attendance-salary/view-attendance/view-attendance.component';
import { ViewSalaryComponent } from './attendance-salary/view-salary/view-salary.component';
import { AddSpotDriverComponent } from './add-spot-driver/add-spot-driver.component';
import { AddSpotVehicleComponent } from './add-spot-vehicle/add-spot-vehicle.component';
import { HelpDeskComponent } from './help-desk/help-desk.component';
import { FilterPipe } from './filter.pipe';
import { RegisteredVehiclesComponent } from './registered-vehicles/registered-vehicles.component';
import { RegisteredDriversComponent } from './registered-drivers/registered-drivers.component';
import { CarrierScorecardComponent } from './carrier-scorecard/carrier-scorecard.component';
import { ReportsComponent } from './reports/reports.component';
import { AcknowlegdeComponent } from './acknowlegde/acknowlegde.component';
import { ExpressShipmentsDashboardComponent } from './express-shipments-dashboard/express-shipments-dashboard.component';
import { ExpressShipmentsComponent } from './express-shipments/express-shipments.component';
import { CreateTripModalComponent } from './dashboardModals/create-trip-modal/create-trip-modal.component';
import { ExpressDetailsComponent } from './express-shipments/express-details/express-details.component';
import { LoadDashboardComponent } from './load-dashboard/load-dashboard.component';
import { AssignLoadDashboardComponent } from './load-dashboard/assign-load-dashboard/assign-load-dashboard.component';
import { CementLoadDashboardComponent } from './cement-load-dashboard/cement-load-dashboard.component';
import { LoadDashboardAcceptModalComponent } from './dashboardModals/load-dashboard-accept-modal/load-dashboard-accept-modal.component';
import { VehicleMapViewComponent } from './spot-drivers/vehicle-map-view/vehicle-map-view.component';
import { FilterModalComponent } from './own-vehicle-map-view/filter-modal/filter-modal.component';
import { OwnVehicleMapViewComponent } from './own-vehicle-map-view/own-vehicle-map-view.component';
import { ExternalParkingVehiclesComponent } from './external-parking-vehicles/external-parking-vehicles.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InPlantVehiclesComponent } from './in-plant-vehicles/in-plant-vehicles.component';
import { PartialRegistrationComponent } from './partial-registration/partial-registration.component';
import { InterceptorService } from './interceptor.service';
import { PartialRegistrationDashboardComponent } from './partial-registration-dashboard/partial-registration-dashboard.component';
import { EnRouteVehiclesComponent } from './en-route-vehicles/en-route-vehicles.component';
import { VehiclesAtCustomersSiteComponent } from './vehicles-at-customers-site/vehicles-at-customers-site.component';
import { VehiclesUpdateStatusComponent } from './vehicles-update-status/vehicles-update-status.component';
import { ClosedTripsDetailsComponent } from './closed-trips-details/closed-trips-details.component';
import { NoDataComponent } from './no-data/no-data.component';
import { JsplDetailsViewComponent } from './jspl-details-view/jspl-details-view.component';
import { ControlRoomComponent } from './control-room/control-room.component';
import { CommonTableComponent } from './common-table/common-table.component';
import { FreeLoadComponent } from './free-load/free-load.component';
import { EmailsSmsComponent } from './emails-sms/emails-sms.component';
import { AssignLoadComponent } from './assign-load/assign-load.component';
import { CreateConsolidatedInvoiceComponent } from './create-consolidated-invoice/create-consolidated-invoice.component';
import { AddShortageComponent } from './add-shortage/add-shortage.component';
import { ConsolidatedInvoiceComponent } from './consolidated-invoice/consolidated-invoice.component';
import { CreateCreditNoteComponent } from './create-credit-note/create-credit-note.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { MwgDashboardComponent } from './mwg-dashboard/mwg-dashboard.component';
import { EpodsPrevComponent } from './epods-prev/epods-prev.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { EditConsolidatedInvoiceComponent } from './edit-consolidated-invoice/edit-consolidated-invoice.component';
import { CommonConfirmationComponent } from './common-confirmation/common-confirmation.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { EpodPreviewComponent } from './epod-preview/epod-preview.component';
import { RequestCallBackComponent } from './request-call-back/request-call-back.component';
import { JsonAnimatorComponent } from './json-animator/json-animator.component';
import { LtlOrdersComponent } from './ltl-orders/ltl-orders.component';
import { ViewLtlOrdersComponent } from './view-ltl-orders/view-ltl-orders.component';
import { OdcDashboardComponent } from './odc-dashboard/odc-dashboard.component';
import { SimConsentComponent } from './sim-consent/sim-consent.component';
import { NoZoneComponent } from './no-zone/no-zone';


export function playerFactory() {
  return player;
}

const MY_DATE_FORMATS = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};

@NgModule({
  entryComponents: [
    AcceptModalComponent,
    RolesComponent,
    FeaturesComponent,
    AssignModalComponent,
    AssignLoadComponent,
    AddVehicleComponent,
    AddDriverComponent,
    ShipmentDetailsComponent,
    MapModalComponent,
    FavoriteLocationComponent,
    AccessoriesComponent,
    PermitsComponent,
    OrganisationNameComponent,
    LoadTypeComponent,
    BidDetailsModalComponent,
    AttachDriverComponent,
    ConfirmationModalComponent,
    CreateBillModalComponent,
    DeleteBillModalComponent,
    ShareComponent,
    SpotOnDriverComponent,
    DriverPathComponent,
    BulkUploadComponent,
    EditVehicleComponent,
    ViewDriverComponent,
    ViewVehicleComponent,
    ReAssignComponent,
    SubscribeComponent,
    SendEmailComponent,
    AddUserComponent,
    AddUnitComponent,
    SnackbarNotifComponent,
    DeadlineModalsComponent,
    PreShipmentModalsComponent,
    PostShipmentModalsComponent,
    InvoiceHistoryComponent,
    PaymentVoucherCreateComponent,
    PaymentVoucherViewComponent,
    OrderDetailsComponent,
    CreditNoteComponent,
    HolidayListComponent,
    AddOwnFleetDriverComponent,
    AddAttendanceComponent,
    HolidaysListComponent,
    BulkUploadVehicleComponent,
    ViewAttendanceComponent,
    ViewSalaryComponent,
    AddSpotDriverComponent,
    AddSpotVehicleComponent,
    CreateTripModalComponent,
    ExpressDetailsComponent,
    LoadDashboardAcceptModalComponent,
    FilterModalComponent,
    JsplDetailsViewComponent,
    CommonTableComponent,
    CreateConsolidatedInvoiceComponent,
    AddShortageComponent,
    CreateCreditNoteComponent,
    FileUploaderComponent,
    EditConsolidatedInvoiceComponent,
    CommonConfirmationComponent,
    EpodPreviewComponent,
    ViewLtlOrdersComponent
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    SignUpComponent,
    HeaderComponent,
    GanttDashboardComponent,
    OrderDashboardComponent,
    AcceptModalComponent,
    AssignModalComponent,
    FeaturesComponent,
    RateCardBasicComponent,
    UserDetailsComponent,
    EntityDetailsComponent,
    FeaturesComponent,
    RolesComponent,
    VehiclesComponent,
    VehiclesDashboardComponent,
    AddVehicleComponent,
    DriversComponent,
    AddDriverComponent,
    AttendanceComponent,
    ShipmentsDashboardComponent,
    MapModalComponent,
    ShipmentDetailsComponent,
    PostShipmentComponent,
    SearchPipe,
    FavoriteLocationComponent,
    AccessoriesComponent,
    PermitsComponent,
    LoadTypeComponent,
    OrganisationNameComponent,
    HelpComponent,
    BidOrderComponent,
    OpenBidsComponent,
    BidDetailsModalComponent,
    AttachDriverComponent,
    AttachVehicleComponent,
    ConfirmationModalComponent,
    DriverMapViewComponent,
    InvoicesComponent,
    BillsComponent,
    ForgotPasswordComponent,
    InvoicesComponent,
    ResetPasswordComponent,
    CreateBillComponent,
    CreateBillModalComponent,
    DeleteBillModalComponent,
    ShipmentsMapComponent,
    UnitSettingsComponent,
    ShareComponent,
    SpotOnDriverComponent,
    DriverPathComponent,
    TaxSettingsComponent,
    MyShippersComponent,
    EditVehicleComponent,
    BulkUploadComponent,
    SpotDriversComponent,
    ViewDriverComponent,
    ViewVehicleComponent,
    ReAssignComponent,
    SubscribeComponent,
    SendEmailComponent,
    CanvasComponent,
    AddUserComponent,
    AddUnitComponent,
    DeletedShipmentsComponent,
    NumberFormatPipe,
    SnackbarNotifComponent,
    OverviewComponent,
    DeadlineModalsComponent,
    PreShipmentModalsComponent,
    PostShipmentModalsComponent,
    DashboardSettingsComponent,
    InvoicePreviewComponent,
    AccountSettingsComponent,
    InvoiceHistoryComponent,
    PaymentVoucherComponent,
    PaymentVoucherCreateComponent,
    PaymentVoucherViewComponent,
    PaymentAdviceComponent,
    NoZoneComponent,
    // Gantt2Component,
    OrderDetailsComponent,
    CreditNoteComponent,
    CreditNotesComponent,
    DebitNotesComponent,
    DbclickDirective,
    HolidayListComponent,
    AddOwnFleetDriverComponent,
    DocPreviewComponent,
    AddAttendanceComponent,
    HolidaysListComponent,
    BulkUploadVehicleComponent,
    AttendanceSalaryComponent,
    ViewAttendanceComponent,
    ViewSalaryComponent,
    AddSpotDriverComponent,
    AddSpotVehicleComponent,
    HelpDeskComponent,
    FilterPipe,
    RegisteredVehiclesComponent,
    RegisteredDriversComponent,
    CarrierScorecardComponent,
    ReportsComponent,
    AcknowlegdeComponent,
    ExpressShipmentsDashboardComponent,
    ExpressShipmentsComponent,
    CreateTripModalComponent,
    ExpressDetailsComponent,
    LoadDashboardComponent,
    AssignLoadDashboardComponent,
    CementLoadDashboardComponent,
    LoadDashboardAcceptModalComponent,
    VehicleMapViewComponent,
    FilterModalComponent,
    OwnVehicleMapViewComponent,
    ExternalParkingVehiclesComponent,
    InPlantVehiclesComponent,
    PartialRegistrationComponent,
    PartialRegistrationDashboardComponent,
    EnRouteVehiclesComponent,
    VehiclesAtCustomersSiteComponent,
    VehiclesUpdateStatusComponent,
    ClosedTripsDetailsComponent,
    NoDataComponent,
    JsplDetailsViewComponent,
    ControlRoomComponent,
    CommonTableComponent,
    FreeLoadComponent,
    EmailsSmsComponent,
    AssignLoadComponent,
    CreateConsolidatedInvoiceComponent,
    AddShortageComponent,
    ConsolidatedInvoiceComponent,
    CreateCreditNoteComponent,
    FileUploaderComponent,
    MwgDashboardComponent,
    EpodsPrevComponent,
    PdfViewerComponent,
    EditConsolidatedInvoiceComponent,
    CommonConfirmationComponent,
    LandingPageComponent,
    EpodPreviewComponent,
    RequestCallBackComponent,
    JsonAnimatorComponent,
    LtlOrdersComponent,
    ViewLtlOrdersComponent,
    OdcDashboardComponent,
    SimConsentComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MatTableModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    HttpClientModule,
    MatSelectModule,
    InfiniteScrollModule,
    MatMenuModule,
    MatSortModule,
    MatPaginatorModule,
    FormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatGridListModule,
    MatStepperModule,
    MatCardModule,
    MatInputModule,
    MatChipsModule,
    MatSliderModule,
    MatBadgeModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    DragDropModule,
    MatIconModule,
    NgxMaterialTimepickerModule,
    PasswordStrengthMeterModule,
    AngularFireMessagingModule,
    NgxEchartsModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatButtonToggleModule,
    MatListModule,
    MatTooltipModule,
    PdfViewerModule,
    AngularFireModule.initializeApp(environment.firebase),
    LottieModule.forRoot({ player: playerFactory}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
    GaugeChartModule,
    NgxEchartsModule,
    // MatPaginatorModule
  ],
  providers: [{ provide: DateAdapter, useClass: OurDateAdapter }, {
    provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS
  }, { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    HttpService, StorageService, SocketService, MessagingService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },{
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptorService,
    multi: true
  }, ValidationService, SnackbarService, RoleGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?langVersion=' + environment.langVersion);
}
